/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SharedContactDealerWrapper_item$ref = any;
export type PdpSharedMakeOfferButton_item$ref = any;
export type PdpSharedMakeOfferButton_item = {
    readonly serviceId: string | null;
    readonly makeOfferVpvParams?: unknown | null;
    readonly contemporaryTrackingString: string;
    readonly title: string | null;
    readonly seller: {
        readonly serviceId: string | null;
    } | null;
    readonly pricing: {
        readonly totalAmount: {
            readonly amount: number | null;
        } | null;
    } | null;
    readonly categoryCode: string | null;
    readonly browseUrl: string | null;
    readonly " $fragmentRefs": SharedContactDealerWrapper_item$ref;
    readonly " $refType": PdpSharedMakeOfferButton_item$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "PdpSharedMakeOfferButton_item",
        "type": "Item",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "userId",
                "type": "String"
            },
            {
                "kind": "RootArgument",
                "name": "isClient",
                "type": "Boolean"
            }
        ],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "contemporaryTrackingString",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "seller",
                "storageKey": null,
                "args": null,
                "concreteType": "Seller",
                "plural": false,
                "selections": [
                    (v0 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "pricing",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemPricing",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "totalAmount",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "amount",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "categoryCode",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "browseUrl",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "FragmentSpread",
                "name": "SharedContactDealerWrapper_item",
                "args": null
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isClient",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": "makeOfferVpvParams",
                        "name": "pdpTrackingVpvParams",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "excludedPurchaseStatuses",
                                "value": [
                                    "RET",
                                    "CUST"
                                ]
                            },
                            {
                                "kind": "Variable",
                                "name": "userId",
                                "variableName": "userId"
                            }
                        ],
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '87d1ec2111222ae1c77a08b6ad93ac28';
export default node;
